var map = {
	"./home/carry-bag-dashboard/carry-bag-dashboard.module": [
		"./src/app/home/carry-bag-dashboard/carry-bag-dashboard.module.ts",
		"home-carry-bag-dashboard-carry-bag-dashboard-module"
	],
	"./home/oos-products/oos-products.module": [
		"./src/app/home/oos-products/oos-products.module.ts",
		"home-oos-products-oos-products-module"
	],
	"./home/orders-history/orders-history.module": [
		"./src/app/home/orders-history/orders-history.module.ts",
		"home-orders-history-orders-history-module"
	],
	"./home/payment/payment.module": [
		"./src/app/home/payment/payment.module.ts",
		"home-payment-payment-module"
	],
	"./home/pickup-order/pickup-order.module": [
		"./src/app/home/pickup-order/pickup-order.module.ts",
		"home-pickup-order-pickup-order-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;